<template>
  <section>
    <Header :class="{scrolled: isScrolled}"/>
    <div class="the-section" style="overflow: hidden;">
      <div class="section s1">
        <h4>Web animation</h4>
        <p>Web nowadays not just like displaying static motionless content.
          With the latest technology we able to create beatufull, full motion,
          extra satisfying content.</p>
      </div>
      <div class="mapscr">
        <div class="car" :class="car"></div>
        <div class="carCircle"></div>
      </div>
      <div class="plane"></div>
    </div>
    <Joined ref="joined"/>
  </section>
</template>

<script>
import Joined from '@/components/Joined.vue';
import Header from '@/components/Header.vue';

export default {
  name: 'home',
  components: {
    Joined,
    Header,
  },
  data() {
    return {
      isScrolled: false,
      moonOk: true,
      car: {
        c1: false,
        c2: false,
        c3: false,
        c4: false,
        c5: false,
        c6: false,
        c7: false,
        c8: false,
        c9: false,
        c10: false,
        c11: false,
      },
    };
  },
  created() {
    document.addEventListener('scroll', this.scrolled);
  },
  destroyed() {
    document.removeEventListener('scroll', this.scrolled);
  },
  computed: {},
  methods: {
    doNothing() {},
    scrolled() {
      this.isScrolled = window.scrollY > 100;
    },
    animateCar() {
      this.car.c1 = false;
      this.car.c2 = false;
      this.car.c3 = false;
      this.car.c4 = false;
      this.car.c5 = false;
      this.car.c6 = false;
      this.car.c7 = false;
      this.car.c8 = false;
      this.car.c9 = false;
      this.car.c10 = false;
      this.car.c11 = false;
      setTimeout(() => {
        this.car.c1 = true;
        setTimeout(() => {
          this.car.c2 = true;
          setTimeout(() => {
            this.car.c3 = true;
            setTimeout(() => {
              this.car.c4 = true;
              setTimeout(() => {
                this.car.c5 = true;
                setTimeout(() => {
                  this.car.c6 = true;
                  setTimeout(() => {
                    this.car.c7 = true;
                    setTimeout(() => {
                      this.car.c8 = true;
                      setTimeout(() => {
                        this.car.c9 = true;
                        setTimeout(() => {
                          this.car.c10 = true;
                          setTimeout(() => {
                            this.car.c11 = true;
                            setTimeout(() => {
                              this.animateCar();
                            }, 3000);
                          }, 300);
                        }, 3000);
                      }, 300);
                    }, 3000);
                  }, 1000);
                }, 2000);
              }, 300);
            }, 4000);
          }, 300);
        }, 3000);
      }, 200);
    },
  },
  mounted() {
    this.animateCar();
  },
};
</script>

<style scoped lang="scss">
.the-section{
  min-height: 100vh;
  padding-top: 80px;
  position: relative;
  .plane{
    width: 80px; height: 80px;
    background-color: red;
    position: absolute;
    left: -80px; bottom: 100px;
    animation: plane-1 5s linear alternate, plane-2 5s linear alternate;
  }
  .mapscr{
    position: relative;
    width: 800px; height: 500px;
    // left: 400px; top: 200px;
    background-image: url(../assets/mapscr.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
  }
  .carCircle{
    position: absolute;
    width: 170px; height: 170px;
    left: 254px; top: 127px;
    border-radius: 50%;
    animation: carCircle 16s linear forwards infinite;
    &:before{
      content: "";
      position: absolute;
      left: -10px; top: 50%;
      width: 30px; height: 40px;
      margin-top: -15px;
      // background-color: yellow;
      background-image: url(../assets/car-top-view.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  .car{
    position: absolute;
    left: 360px; top: 520px;
    width: 40px; height: 30px;
    // background-color: green;
    transform: rotate(-48deg);
    background-image: url(../assets/car-top-view-rotated.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    &.c1{
      transition: all 3s ease;
      left: 460px; top: 400px;
    }
    &.c2{
      transition: all .3s ease;
      transform: rotate(-134deg);
    }
    &.c3{
      transition: all 4s ease;
      left: 400px; top: 340px;
    }
    &.c4{
      transition: all .3s ease;
      transform: rotate(-40deg);
    }
    &.c5{
      transition: all 2s linear;
      left: 440px; top: 300px;
    }
    &.c6{
      transition: all 1s linear;
      transform: rotate(-90deg);
      left: 460px; top: 246px;
    }
    &.c7{
      transition: all 3s ease;
      top: 190px;
    }
    &.c8{
      transition: all .3s ease;
      transform: rotate(0);
    }
    &.c9{
      transition: all 3s ease;
      top: 180px;
      left: 700px;
    }
    &.c10{
      transition: all .3s ease;
      transform: rotate(-94deg);
    }
    &.c11{
      transition: all 3s linear;
      left: 684px; top: -30px;
    }
  }
}

@keyframes carCircle {
  to {transform:rotate(360deg);}
}
@keyframes plane-1 {
  to {transform:translateY(-200vh);}
}
@keyframes plane-2 {
  to {transform:translateX(100vw);}
}
</style>
